import PropTypes from "prop-types";
import React from "react";

const NetworkSearchItem = ({ iconSrc, altText, displayText }) => {
  return (
    <li>
      <img src={iconSrc} alt={altText} className="float-left" />
      <span className="float-left-txt">{displayText}</span>
    </li>
  );
};

NetworkSearchItem.propTypes = {
  iconSrc: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
  displayText: PropTypes.string.isRequired,
};

export default NetworkSearchItem;
